import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'

@Injectable({ providedIn: 'root' })
export class SugestaoAgrupamentoService {
  private baseUrl = environment.baseUrl
  private resource = 'SugestaoAgrupamento'

  constructor(private httpClient: HttpClient) {}

  public gerar(
    contratoId: any,
    janelaMinutos: number,
    agruparPorOrigem: boolean,
    agruparPorDestino: boolean,
    agruparPorVoo: boolean,
    modoAgrupamento = 0,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/gerar/${contratoId}`, {
      janelaMinutos,
      agruparPorOrigem,
      agruparPorDestino,
      agruparPorVoo,
      modoAgrupamento,
    })
  }

  public confirmar(
    contratoId: any,
    grupos: {
      itemPropostaId: number
      passageiroIds: string[]
      observacao?: string | null
      servicosAdicionais?: { servicoAdicionalId: number; quantidade: number; taxa: number; valorUnitario: number; valorTotal: number; observacao?: string | null }[]
    }[],
    coordenadores?: {
      tipoTrechoId: number
      coordenadores: { coordenadorId: number; dataServico?: string | null; hora?: string | null; local?: string | null }[]
    }[],
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/confirmar/${contratoId}`, {
      grupos,
      coordenadores,
    })
  }

  public moverPassageiro(payload: {
    passageiroId: string
    itemOrigemId: string
    itemDestinoId: string
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/mover-passageiro`, payload)
  }

  public removerPassageiro(payload: {
    passageiroId: string
    itemContratoId: string
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/remover-passageiro`, payload)
  }

  public getVeiculosTroca(itemContratoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/veiculos-troca/${itemContratoId}`)
  }

  public previewTrocaVeiculo(payload: {
    novoItemPropostaId: number
    passageiroIds: string[]
  }): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/preview-troca-veiculo`, payload)
  }

  public getVeiculosProposta(propostaId: number, quantidade?: number): Observable<ResponseRequestModel> {
    const params = quantidade != null ? `?quantidade=${quantidade}` : ''
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/veiculos-proposta/${propostaId}${params}`)
  }

  public deletarItem(itemContratoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/deletar-item/${itemContratoId}`, {})
  }

  public deletarItens(itemContratoIds: string[]): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/deletar-itens`, { itemContratoIds })
  }

  public removerAssociacoesItem(itemContratoId: string): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/remover-associacoes-item/${itemContratoId}`, {})
  }
}
